import { render, staticRenderFns } from "./AccreditedTermsUse.vue?vue&type=template&id=20a1991e&scoped=true&"
import script from "./AccreditedTermsUse.vue?vue&type=script&lang=js&"
export * from "./AccreditedTermsUse.vue?vue&type=script&lang=js&"
import style0 from "./AccreditedTermsUse.vue?vue&type=style&index=0&id=20a1991e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a1991e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
